import { Box, Typography, Avatar } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { tokens } from '../../../theme'

export function BenefitItem({ title, description }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
      <Avatar
        sx={{
          width: 24,
          height: 24,
          bgcolor: tokens.colors.primary.main,
          mt: 0.5,
        }}
      >
        <CheckIcon sx={{ fontSize: 14 }} />
      </Avatar>

      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontFamily: tokens.typography.fontFamily.body,
            fontWeight: 600,
            fontSize: 14,
            color: tokens.colors.gray.text,
            lineHeight: 1.5,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontFamily: tokens.typography.fontFamily.body,
            fontSize: 12,
            color: 'rgba(19, 19, 19, 0.8)',
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  )
}
